import { render, staticRenderFns } from "./FailedDelivery.vue?vue&type=template&id=7dbf3208&scoped=true&"
import script from "./FailedDelivery.vue?vue&type=script&lang=js&"
export * from "./FailedDelivery.vue?vue&type=script&lang=js&"
import style0 from "./FailedDelivery.vue?vue&type=style&index=0&id=7dbf3208&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf3208",
  null
  
)

export default component.exports